export default {
  namespaced: true,
  state: {
    cardBody: { height: "calc(100% - 30px)" }
  },
  mutations: {},
  actions: {}
};
